module.exports = __webpack_public_path__ + "img/20170704_135648_089.82bf1243.jpg";